<script setup lang="ts">
import { useTemplateRef } from 'vue';
import { useBlockInteractiveZone } from '#layers/block-engine/utils/block/interactive-zone';

/**
 * Renders an explicit interactive region for block content inside the builder.
 */
defineOptions({ inheritAttrs: false });

const { disabled } = defineProps<{
	disabled?: boolean;
}>();

const wrapperRef = useTemplateRef<HTMLElement>('wrapper');
const { active } = useBlockInteractiveZone(wrapperRef, () => disabled);
</script>

<template>
	<div
		v-if="active"
		v-bind="$attrs"
		ref="wrapper"
		class="pointer-events-auto"
		:style="{ display: 'contents' }"
	>
		<slot />
	</div>
	<slot v-else />
</template>
